import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ContactPage } from './contact';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    ContactPage,
  ],
  imports: [
    IonicPageModule.forChild(ContactPage),
    ComponentsModule,
  ],
})
export class ContactPageModule {}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.module.ts